import { Box, Button, Form, FormField, TextInput } from "grommet";
import React, { useState } from "react";

function VerificationCode({ handleSubmit }) {
    const [error, setError] = useState();

    const handleFormSubmit = ({ value: { code } }) => {
        handleSubmit(code).catch(({ message }) => {
            setError(message);
        });
    }

    return (
        <Form onSubmit={handleFormSubmit}>
            {error && <p className="status-error" role="alert">Error: {error}</p>}
            <p>Please enter the verification code emailed to your new email address.</p>
            <FormField name="code" htmlFor="verification-code" label="Verification Code" required>
                <TextInput required id="verification-code" type="text" maxLength={6} name="code"/>
            </FormField>
            <Box direction="row" gap="medium">
                <Button type="submit" primary label="Save"/>
            </Box>
        </Form>
    )
}

export default VerificationCode;